
import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section 
      className="relative min-h-screen flex items-start justify-center bg-cover bg-center pt-20"
      style={{
        backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05)), url('https://public.readdy.ai/ai/img_res/4a56e9b15bf9d45e73bf8d91c8188729.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
        <div className="max-w-4xl mx-auto">
          <div className="text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
              <span className="block text-purple-600 drop-shadow-lg">Next Up. Next Level.</span>
              <span className="block text-purple-700 text-5xl md:text-7xl drop-shadow-lg">
                NEXTZEN
              </span>
            </h1>
          </div>
          <p className="text-xl md:text-2xl mb-8 text-purple-600 drop-shadow-md max-w-3xl mx-auto">
            Professional soccer coaching for kids and youth aged 4-17 in Folsom, CA. Build skills, confidence, and character through the beautiful game.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link
              to="/programs"
              className="bg-purple-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-purple-700 transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              View Programs
            </Link>
            <Link
              to="/register"
              className="bg-transparent border-2 border-white text-purple-600 px-8 py-4 rounded-full text-lg font-semibold hover:bg-white hover:text-purple-600 transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              Register Now
            </Link>
          </div>
        </div>
      </div>
      
      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl"></i>
      </div>
    </section>
  );
}
